import { render, staticRenderFns } from "./hqglLogisticsTransfer.vue?vue&type=template&id=0f9d3d70&scoped=true&"
import script from "./hqglLogisticsTransfer.vue?vue&type=script&lang=js&"
export * from "./hqglLogisticsTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9d3d70",
  null
  
)

export default component.exports